import { ApolloLink } from '@apollo/client';
import ApolloLinkTimeout from 'apollo-link-timeout';
/*
  A link to provide timeout functionality.
 This can be overriden with the timeoutLink context.
*/
export const makeTimeoutLink = (maxTimeoutDuration) => new ApolloLink((operation, forward) => {
    var _a, _b, _c, _d, _e, _f;
    const existingContext = operation.getContext();
    const enableTimeoutLink = (_c = (_b = (_a = existingContext === null || existingContext === void 0 ? void 0 : existingContext.linkOptions) === null || _a === void 0 ? void 0 : _a.timeoutLink) === null || _b === void 0 ? void 0 : _b.enableTimeout) !== null && _c !== void 0 ? _c : true;
    const timeoutDuration = (_f = (_e = (_d = existingContext === null || existingContext === void 0 ? void 0 : existingContext.linkOptions) === null || _d === void 0 ? void 0 : _d.timeoutLink) === null || _e === void 0 ? void 0 : _e.maxTimeoutDuration) !== null && _f !== void 0 ? _f : maxTimeoutDuration;
    if (!enableTimeoutLink) {
        return forward(operation);
    }
    const timeoutLink = new ApolloLinkTimeout(timeoutDuration);
    return timeoutLink.request(operation, forward);
});
